<!--
 * @Description: 机构审核列表页面
 * @Author: wanqian sunhuihong
 * @Date: 2022-03-16 16:43:52
-->
<template>
   <div class="body">
     <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 240px" v-model="filterParams.institutionId" filterable clearable 
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left">
        <span class="search-title">提交时间：</span>
        <el-date-picker v-model="dateRange" type="daterange" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="dateRangePickerOptions"
					style="width: 240px" size="small">
				</el-date-picker>
      </el-col>
      <el-col  :span="8" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">搜 索</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable"
      header-cell-class-name="table-header-color" row-key="id">
      <el-table-column prop="institutionName" label="机构名称" min-width="16%" align="left">
        <template slot-scope="scope">
          {{scope.row.institutionName ? scope.row.institutionName : '--'}}
        </template>
      </el-table-column>
      <el-table-column label="所在地区" min-width="16%" align="left">
        <template slot-scope="scope">
        {{scope.row.province ? (scope.row.province + '/') : '-'}}{{scope.row.city ? (scope.row.city + '/') : '-'}}
        {{scope.row.county ? scope.row.county : ''}}
        </template>
      </el-table-column>
      <el-table-column prop="username" label="注册账户名" min-width="12%" align="left">
        <template slot-scope="scope">
          {{scope.row.username ? scope.row.username : '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="moblie" label="注册手机号" min-width="12%" align="left">
        <template slot-scope="scope">
          {{scope.row.moblie ? scope.row.moblie : '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="submitTime" label="提交时间" sortable min-width="13%" align="left">
        <template slot-scope="scope">{{dateFormat(scope.row.submitTime)}}</template>
      </el-table-column>
      <el-table-column label="审核状态" min-width="8%" align="left">
				<template slot-scope="scope">
          <!-- 0-未审核 1-审核通过 2-审核拒绝 3-撤回 -->
					<span v-if="scope.row.reviewHistoryList && !scope.row.reviewHistoryList.length"
						:style="{color: scope.row.status == '2' || scope.row.status == '35' ?
						'#FF0909': scope.row.status == '0'? '#999999': '#606266'}">
						{{scope.row.statusText}}
					</span>
					<review-tooltip v-else :reviewStatus="scope.row.status" :statusText="scope.row.statusText"
						:data="scope.row.reviewHistoryList">
					</review-tooltip>
				</template>
      </el-table-column>
      <el-table-column prop="reviewTime" label="审核时间" sortable min-width="13%" align="left">
        <template slot-scope="scope">{{scope.row.reviewTime ? dateFormat(scope.row.reviewTime) : '- -'}}</template>
      </el-table-column>
      <el-table-column label="操作" min-width="10%" align="left">
        <template slot-scope="scope">
          <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
          <template v-if="scope.row.status == 0 && dataPvgList.includes('INST_7_REVIEW')">
            <el-divider direction="vertical"></el-divider>
            <el-button @click="handleReview(scope.row)" type="text" size="small">审核</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
    
    <!-- 机构审核详情弹框 -->
    <inst-review-details :visible="showReviewDetailsDialog" :mode="dialogMode" :instReviewId="instReviewId" 
      :isGlobalAdmin="isGlobalAdmin"  @handle-review-inst="handleInstReview"  @close-dialog="closeDetailsDialog" />
    <!-- 审核意见弹框 -->
    <review-comments-dialog :showReviewCommentsDialog="showReviewCommentsDialog" :reviewStatus = "reviewStatus"
			@handle-close-review-comments-dialog="handleCloseReviewCommentsDialog"
			@handle-review-comments-msg="handleReviewCommentsMsg" />
   </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import InstReviewDetails from './components/InstReviewDetails.vue'
import ReviewCommentsDialog from './components/ReviewCommentsDialog.vue'
import ReviewTooltip from './components/ReviewTooltip.vue'

export default {
  name: 'InstReviewList',
  components: {
    'inst-review-details': InstReviewDetails,
    'review-comments-dialog': ReviewCommentsDialog,
		'review-tooltip': ReviewTooltip
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      dateRange: null,
			dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false),
      institutionList: [],
      srcInstitutionList: [],
      dataTable: [],
      totalNumber: 0,
      instReviewId: 0,

      //以下是对话框使用
      showReviewDetailsDialog: false,
      dialogMode: '',
      showReviewCommentsDialog: false,
      reviewStatus: '',
      reviewParams: {},
      isGlobalAdmin: true,
    }
  },

  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods:{
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listTable();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INST'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_INSTITUTION_REVIEW_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data;
            this.srcInstitutionList = result.data;
            resolve();
          }
        })
      })
    },

    listTable() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams, 
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET', 
          url: Constant.URL_PAGE_INSTITUTION_REVIEWS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    handleQuery() {
      this.filterParams.page = 1;
      if (this.dateRange && this.dateRange.length) {
        this.filterParams.begDate = this.dateUtil.dateFormat(this.dateRange[0]);
        this.filterParams.endDate = this.dateUtil.dateFormat(this.dateRange[1]);
      } else {
        this.filterParams.begDate = '';
        this.filterParams.endDate = '';
      }
      this.listTable();
    },

    handleDetailClick(row) {
      this.showReviewDetailsDialog = true;
      this.dialogMode = 'details';
      this.instReviewId = row.id;
    },

    handleReview(row) {
      this.instReviewId = row.id;
      this.reviewParams.id = row.id;
      this.reviewParams.version = row.version;
      this.reviewStatus = "";
      this.showReviewCommentsDialog = true;
    },

    closeDetailsDialog(refresh) {
      this.showReviewDetailsDialog = false;
      if (refresh) {
        this.listTable();
      }
    },

    //关闭审核意见弹框
    handleCloseReviewCommentsDialog(item) {
      this.showReviewCommentsDialog = item;
    },

    //详情里面审核通过或者驳回操作按钮
    handleInstReview(reviewStatus, version) {
      this.reviewParams.id = this.instReviewId;
      this.reviewParams.version = version;
      this.reviewStatus = reviewStatus;
      this.showReviewCommentsDialog = true;
    },

    //审核意见框确定
    handleReviewCommentsMsg(comment, status) {
      this.reviewParams.comment = comment;
      this.reviewParams.status = status;
      this.queryReviewStatusChange();
      this.showReviewCommentsDialog = false;
      this.showReviewDetailsDialog = false;
    },

    queryReviewStatusChange() {
      let header = this.encryptionUtil.signatureBody(this.reviewParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_INSTITUTION_REVIEW_STATUS,
        param: this.reviewParams,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.listTable();
      });
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listTable();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listTable();
    },

    dateFormat(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '审核管理', text2: '机构审核'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f2f3f4;
}

.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.text-light-gray {
  color: #999999;
}

.text-red {
  color: #FF0909;
}
</style>


// WEBPACK FOOTER //
// src/components/review/InstReviewList.vue